import { removeToken } from '@/util/token'
import * as types from './mutation-type'

export default {
  setUserAndState ({ commit }) {
    console.log('setUserAndState')
    // 如果登陆成功，设置logined标志位
    commit(types.SET_LOGINED, true)
    // 设置全局用户状态
    // commit(types.SET_USER, user)
  },

  loginOut ({ commit }) {
    removeToken()
    commit(types.REMOVE_LOGINED, false)
  },

  readMessage ({ commit }, message) {
    commit(types.REMOVE_UNREAD_MESSAGE, message.id)
    commit(types.ADD_READED_MESSAGE, message)
  }
}



// WEBPACK FOOTER //
// ./src/store/action.js